import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/app-v2/',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 1 }
    }
  },
  routes: [
    {
      path: '/event-registered/:id',
      name: 'EventRegistered',
      component: () => import('@/views/EventRegistered'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/complete-entry/:id',
      name: 'CompleteEntry',
      component: () => import('@/views/CompleteEntry'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/pay-for-event/:id',
      name: 'PayForEvent',
      component: () => import('@/views/EventRegistered'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/special-invite/:id/:code',
      name: 'SpecialInvite',
      component: () => import('@/views/EnterEvent'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/enter-event/:action/:id',
      name: 'EnterEventOverride',
      component: () => import('@/views/EnterEvent'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/enter-event/:id',
      name: 'EnterEvent',
      component: () => import('@/views/EnterEvent'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/enter-and-pay/:id',
      name: 'PrepaidEvent',
      component: () => import('@/views/PrepaidEntry'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Login')
    },
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/Home'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/capture-score/:id',
      name: 'CaptureScore',
      component: () => import('@/views/CaptureScore'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/capture-score/:id/:evententry',
      name: 'CaptureScoreEventEntry',
      component: () => import('@/views/CaptureScore'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/added-to-waiting-listing/:id',
      name: 'AddedToWaitingList',
      component: () => import('@/views/AddedToWaitingList'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/change-captaincy/:id',
      name: 'ChangeCaptaincy',
      component: () => import('@/views/ChangeCaptaincy'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/join-a-team/:id',
      name: 'JoinATeamStep1',
      component: () => import('@/views/JoinATeamStep1'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/join-a-team/join/:id',
      name: 'JoinATeamStep2',
      component: () => import('@/views/JoinATeamStep2'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/manage-dependants',
      name: 'ManageDependants',
      component: () => import('@/views/ManageDependants'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/manage-dependants/add',
      name: 'AddDependant',
      component: () => import('@/views/EditDependant'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/manage-dependants/:id',
      name: 'EditDependant',
      component: () => import('@/views/EditDependant'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/manage-team/:id',
      name: 'ManageTeam',
      component: () => import('@/views/ManageTeam'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/manage-grouped-team/:id',
      name: 'ManageGroupedTeam',
      component: () => import('@/views/ManageGroupedTeam'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/view-team/:id',
      name: 'ViewTeam',
      component: () => import('@/views/ViewTeam'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/sign-up-judge/:id',
      name: 'SignUpJudge',
      component: () => import('@/views/JudgeSignup'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/judge-signed-up/:id',
      name: 'JudgeSignedUp',
      component: () => import('@/views/JudgeSignedUp'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/sign-up-spectator/:id',
      name: 'SignUpSpectator',
      component: () => import('@/views/SpectatorSignup'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/spectator-signed-up/:id',
      name: 'SpectatorSignedUp',
      component: () => import('@/views/SpectatorSignedUp'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/sign-up-volunteer/:id',
      name: 'SignUpVolunteer',
      component: () => import('@/views/VolunteerSignup'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/volunteer-signed-up/:id',
      name: 'VolunteerSignedUp',
      component: () => import('@/views/VolunteerSignedUp'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/edit-profile',
      name: 'EditProfile',
      component: () => import('@/views/EditProfile'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/finalize-team-entry/:id',
      name: 'TeamMemberFinalize',
      component: () => import('@/views/TeamMemberFinalize'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/view-workouts/:id',
      name: 'ViewWorkouts',
      component: () => import('@/views/ViewWorkouts'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/wodproof-offer',
      name: 'WodProofOffer',
      component: () => import('@/views/WodProofOffer'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/order-shirts',
      name: 'OrderShirts',
      component: () => import('@/views/OrderShirts'),
      meta: {
        authenticated: true
      }
    }
  ]
})
